import { initRemoteSettings, onSettingsLoadingStateChanged, onSettingsReady, settingsState } from "../settings/index.js";
import { LoadedState } from "../shared/index.js";
import { initTracker, onTrackerReady, trackerState } from "../tracker/index.js";
import { loadBrowserSdks } from "./core-loader.js";
let cache = {};
const state = {
    app: '',
    sdk: {
        settings: {
            state: settingsState,
            onLoadingStateChanged: onSettingsLoadingStateChanged,
            onReady: onSettingsReady,
            init: initRemoteSettings
        },
        tracker: {
            state: trackerState,
            init: initTracker,
            onReady: onTrackerReady
        }
    }
};
const initialize = ({ config, sdks, app }) => {
    if (state.app) {
        return cache;
    }
    state.app = app;
    const win = window;
    win.pulseReady = win.pulseReady || [];
    win.dataLayer = win.dataLayer || [];
    pulseReady.push({
        sdk: sdks[0],
        onReady: () => {
            pulse
                .init(Object.assign(Object.assign({ app }, config.settings), config.tracker))
                .then(() => sdks.forEach((sdk) => state.sdk[sdk].onReady()))
                .catch(console.error);
        }
    });
    loadBrowserSdks(sdks, state)
        .then(() => {
        sdks.forEach((sdk) => {
            var _a, _b;
            (_b = (_a = state.sdk[sdk]).onLoadingStateChanged) === null || _b === void 0 ? void 0 : _b.call(_a, LoadedState.LOADED);
        });
    })
        .catch(() => {
        sdks.forEach((sdk) => {
            var _a, _b;
            (_b = (_a = state.sdk[sdk]).onLoadingStateChanged) === null || _b === void 0 ? void 0 : _b.call(_a, LoadedState.FAILED_TO_LOAD_IN_BROWSER);
        });
    });
    cache = sdks.reduce((acc, sdk) => (Object.assign(Object.assign({}, acc), { [sdk]: state.sdk[sdk].init(config[sdk] || {}, () => loadBrowserSdks(sdks, state)) })), {});
    return cache;
};
export { initialize as initializeBrowserPulse, state as appState };
//# sourceMappingURL=core.js.map